<template>
  <div class="rolemanage">
    <el-tabs
      v-model="editableTabsValue"
      type="border-card"
      @tab-remove="removeTab"
    >
      <el-tab-pane
        label="角色列表"
        name="main_table"
        v-loading="loading"
        element-loading-text="拼命加载中!"
      >
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="6" class="top-box">
            <el-button
              icon="el-icon-plus"
              @click="addTab"
              size="mini"
              type="primary "
              :disabled="accessControl.rolemanageadd"
              >新增
            </el-button>
          </el-col>
          <el-form :inline="true" class="top-box search">
            <el-input
              style="width: 200px"
              v-model="main_query_param.name"
              placeholder="请输入名称"
              size="mini"
            ></el-input>
            <el-button
              type="primary"
              size="mini"
              @click="onQuery"
              icon="el-icon-search"
              >搜索</el-button
            >
          </el-form>
        </el-row>
        <el-table
          :data="roleList"
          style="width: 100%"
          size="mini"
          :height="table_height"
        >
          <el-table-column prop="name" label="名称" min-width="320">
            <template #default="scope">
              <el-link @click.prevent="formClick(scope.row)">
                {{ scope.row.name }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            min-width="320"
          ></el-table-column>
          <el-table-column label="操作" width="80" align="center" fixed="right">
            <template #default="scope">
              <el-tooltip content="编辑" placement="top">
                <i
                  type="primary"
                  @click.prevent="
                    accessControl.rolemanageview
                      ? accessControl.rolemanageview
                      : formClick(scope.row)
                  "
                  class="el-icon-edit icon"
                ></i>
              </el-tooltip>
              <el-tooltip
                :disabled="accessControl.rolemanagedel"
                content="删除"
                placement="top"
              >
                <i
                  type="primary"
                  @click.prevent="
                    accessControl.rolemanagedel
                      ? accessControl.rolemanagedel
                      : deleteRole(scope.row.row_id)
                  "
                  class="el-icon-delete icon"
                  style="padding: 2px"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging_style">
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            background
            style="margin-top: 5px"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dataTotal"
            @current-change="main_fenyeChenge"
            @size-change="pageSizeChangeHandle"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane
        v-for="item in editableTabs"
        :key="item.name"
        :label="item.name"
        :name="item.name"
        :style="{ height: `${table_height + 26}px` }"
        closable
      >
        <keep-alive>
          <roleedit
            :formData="item.ruleForm"
            :type="item.types"
            :tabName="item.tabName"
            :treeHeight="table_height"
            :systemData="systemData"
            :rightData="rightData"
            :destinationId="destination_id"
            :localUserData="localUserData"
            :accessControl="accessControl"
            @update="handleUpdate"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import roleedit from './RoleEdit'
import { request } from '../dataApi/_request/index'
import Api from '../apis/api'
export default {
  components: {
    roleedit
  },
  watch: {
    localUserData(newVal) {
      this.localUserData = newVal
    }
  },
  props: {
    userData: {
      type: Object,
      require: true,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      localUserData: this.userData,
      loading: false,
      origin_userInfo: [],
      destination_id: '',
      manager_id: '',
      main_query_param: {
        name: ''
      },
      table_height: window.innerHeight - 192,
      currentPage: 1,
      dataTotal: 0,
      pageSize: 20,
      allTabs: [],
      tabIndex: 1,
      editableTabs: [],
      editableTabsValue: 'main_table',
      ruleForm: {},
      searchKey: '',
      roleList: [],
      rolename: '',
      baranchList: [],
      systemData: [],
      rightData: [],
      isReady: false,
      accessControl: {}
    }
  },
  created() {
    this.init()
    this.table_height = window.innerHeight - 186
    // / 监听浏览器窗口变化，动态计算表格高度，
    window.onresize = () => {
      return (() => {
        this.table_height = window.innerHeight - 186
      })()
    }
  },
  methods: {
    init() {
      console.log(this.localUserData, '不同项目所传的值')
      this.destination_id = this.localUserData.data.destination_id
      this.manager_id = this.localUserData.data.row_id
      // 先备份原始数据再修改（如果确实需要修改）
      this.invertFilterValues()
      this.getSystemRight()
      this.getRoleData()
    },
    invertFilterValues() {
      this.accessControl = Object.keys(this.localUserData.data.right).reduce(
        (result, key) => {
          result[key] = !this.localUserData.data.right[key]
          return result
        },
        {}
      )
    },
    // 获取系统权限
    getSystemRight() {
      let params = {
        method: 'post',
        url: Api.getSystem,
        data: { destination_id: this.destination_id },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }
      request(params).then((sys) => {
        let fatherTree = []
        let sonTree = []
        let identify = this.localUserData.data.identify.split(',')
        var result = sys.data.filter(function (v) {
          return identify.indexOf(v.identify) !== -1 // 利用filter方法来遍历出相同的系统
        })

        let that = this
        // 父节点
        result.forEach((item) => {
          if (that.localUserData.newName != null) {
            fatherTree.push({
              id: item.row_id,
              label: that.localUserData.newName,
              identify: item.identify
            })
          } else {
            fatherTree.push({
              id: item.row_id,
              label: item.name,
              identify: item.identify
            })
          }
        })

        this.systemData = fatherTree

        let paramst = {
          method: 'post',
          url: Api.getRight,
          params: {}
        }
        request(paramst).then((res) => {
          this.rightData = res.data
          this.isReady = true
        })
      })
    },
    //请求角色数据
    getRoleData() {
      this.loading = true

      // getRole({
      let params = {
        method: 'post',
        url: Api.getRole,
        data: {
          name: this.main_query_param.name,
          destination_id: this.destination_id,
          manager_id: this.destination_id,
          pageNo: this.currentPage,
          pageNum: this.pageSize
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }
      request(params)
        .then((res) => {
          if (res.errcode == 0) {
            this.roleList = res.data
            this.dataTotal = res.data.length
            this.loading = false
          }
        })
        .catch((error) => {
          this.loading = false
        })
    },
    onQuery() {
      this.getRoleData()
    },
    // 删除
    deleteRole(ids) {
      this.$confirm('确定删除这条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let paramsto = {
          method: 'post',
          url: Api.deleteRole,
          data: { row_id: ids },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        }
        request(paramsto).then((res) => {
          if (res.errcode === 0) {
            this.$message({
              message: '删除成功！',
              type: 'success',
              duration: 800
            })
            // 删除 表格中相应的 数据
            const filteredArr = this.roleList.filter(
              (item) => item.row_id !== ids
            )
            this.roleList = filteredArr
          } else {
            this.$message({
              message: '删除失败！',
              type: 'error',
              duration: 800
            })
          }
          this.loading = false
        })
      })
    },
    handleUpdate(form, name, type) {
      if (type == 'add') {
        this.roleList.unshift(form)
        this.removeTab(name)
      } else if (type == 'close') {
        this.removeTab(name)
      } else {
        this.roleList = this.roleList.map((item) => {
          if (item.row_id == form.row_id) {
            return form
          }
          return item
        })
      }
    },
    // 新增
    addTab() {
      if (!this.isReady) {
        this.$message({
          message: '数据未准备，请稍等！',
          type: 'info',
          duration: 800
        })
        return
      }
      let newTabName = '新增'
      this.ruleForm = {
        row_id: '',
        name: '',
        remark: '',
        destination_id: this.destination_id,
        manager_id: ''
      }
      this.editableTabs.push({
        title: '新增',
        name: '新增',
        ruleForm: this.ruleForm,
        types: 'add',
        tabName: newTabName
      })
      this.editableTabsValue = newTabName
    },
    // 编辑
    formClick(row) {
      if (!this.isReady) {
        this.$message({
          message: '数据未准备，请稍等！',
          type: 'info',
          duration: 800
        })
        return
      }
      let newTabName = `${row.name} - 编辑`
      let bFlag = false
      for (const i in this.editableTabs) {
        if (this.editableTabs[i].name == newTabName) {
          bFlag = true
          break
        }
      }
      if (!bFlag) {
        this.editableTabs.push({
          title: row.name,
          name: newTabName,
          ruleForm: row,
          types: 'edit',
          tabName: newTabName
        })
      }

      this.editableTabsValue = newTabName
    },
    removeTab(targetName) {
      let tabs = this.editableTabs
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        activeName = 'main_table'
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName)
      this.editableTabsValue = activeName
    },
    pageSizeChangeHandle(e) {
      this.pageSize = e
    },
    main_fenyeChenge(e) {
      this.currentPage = e
    }
  }
}
</script>
<style lang="scss" scoped>
.paging_style {
  display: flex;
  justify-content: center;
  align-items: center;
}
.top-box {
  margin-left: 12px;
  :deep(.el-input--mini) {
    padding-right: 4px;
  }
}
.search {
  margin-right: 12px;
}
.search ::v-deep .el-input--mini {
  margin-right: 6px;
}
:deep(.row-bg) {
  margin-bottom: 10px;
}
:deep(.el-link) {
  font-size: 12px;
}
</style>
